// 路由守卫调用element的message  封装message
import { Message } from "element-ui";
export function showMessage(message, type) {
    dangerouslyUseHTMLString: true,
    Message[type](message);
}